import {UseCase} from "@livechat/shared";
import {AnswerTemplateAggregate} from "../aggregates";
import {AnswerTemplateGateway} from "../repositories";
import {map, Observable} from "rxjs";
import {AnswerTemplateDto} from "../../feature/answer-templates/domain/dtos";
import {answerTemplateAggregateToDto} from "../../feature/answer-templates/domain/utils";

export class ListAnswerTemplateUseCase implements UseCase<Array<string>, Observable<Array<AnswerTemplateDto>>> {

  constructor(private answerTemplateRepo: AnswerTemplateGateway) {
  }

  execute(companiesIds: Array<string>): Observable<Array<AnswerTemplateDto>> {
    return this.answerTemplateRepo.list(companiesIds)
      .pipe(map((templates) => templates.map(answerTemplateAggregateToDto)));
  }
}
